import moment from 'moment';
import { openPrintPreview } from './printPreviewHelper';

const defineCss = () => (`
  body { 
    font-family: Arial, sans-serif; 
    margin: 20px; 
    font-size: 12px;
  }
  .header { 
    text-align: center; 
    margin-bottom: 20px; 
    border-bottom: none;
    padding-bottom: 10px;
  }
  .company-name {
    font-size: 18px;
    font-weight: bold;
    color: #2c5aa0;
  }
  .report-title {
    font-size: 16px;
    font-weight: bold;
    margin: 5px 0;
  }

  .date-info {
    font-size: 14px;
    margin: 5px 0;
  }

  table { 
    width: 100%; 
    border-collapse: collapse; 
    margin: 10px 0;
    font-size: 11px;
  }

  th, td { 
    border: 1px solid #000; 
    padding: 3px 5px; 
    text-align: left;
    line-height: 1.2;
  }
  th { 
    background-color: #f0f0f0; 
    font-weight: bold;
    text-align: center;
  }

  .category-section {
    margin: 15px 0;
    page-break-inside: avoid;
  }

  .category-title {
    font-weight: bold;
    background-color: #e6f3ff;
    padding: 5px;
    margin: 5px 0;
    border: 1px solid #000;
  }

  .summary-section {
    margin-top: 20px;
    border-top: none;
    padding-top: 10px;
    page-break-inside: avoid;
  }

  .total-row {
    font-weight: bold;
    background-color: #f5f5f5;
  }
  .text-center { text-align: center; }

  .text-right { text-align: right; }

  .signature-block {
    margin-top: 60px;
    margin-bottom: 10px;
    text-align: right;
    page-break-inside: avoid;
  }

  @media print {
    body { margin: 0; }
    .no-print { display: none; }
    .signature-block { break-inside: avoid; }
  }

  @page {
    margin: 12mm 10mm;
    size: A4;
  }
`);

const generatePrintableContent = (superGroups, orders) => {
  const rows = Array.isArray(orders) ? orders : [];

  const printingTime = moment().format('hh:mm A');
  const firstDate = rows.length > 0 && rows[0].createdAt ? moment(rows[0].createdAt) : moment();
  const collectionDate = firstDate.format('MMMM YYYY');
  const daysInMonth = firstDate.daysInMonth();

  const dayTotals = Array.from({ length: daysInMonth }, () => ({ paid: 0, due: 0, discount: 0, total: 0 }));

  let overallPaid = 0;
  let overallDue = 0;
  let overallDiscount = 0;
  let overallTotal = 0;

  rows.forEach(order => {
    if (!order.createdAt) return;
    const d = moment(order.createdAt);
    // if (d.day() !== firstDate.day()) return;
    const dayIndex = d.date() - 1;
    const paid = Number(order.realPaidAmount || 0);
    const due = Number(order.realDueAmount || 0);
    const discount = Number(order.realDiscountAmount || 0);
    const tot = Number(order.realTotalAmount || 0);

    dayTotals[dayIndex].paid += paid;
    dayTotals[dayIndex].due += due;
    dayTotals[dayIndex].discount += discount;
    dayTotals[dayIndex].total += tot;

    overallPaid += paid;
    overallDue += due;
    overallDiscount += discount;
    overallTotal += tot;
  });

  const bodyRows = dayTotals.map((dt, idx) => {
    const day = idx + 1;
    return `
      <tr>
        <td class="text-center">${day}</td>
        <td class="text-center">৳ ${dt.paid.toLocaleString()}</td>
        <td class="text-center">৳ ${dt.due.toLocaleString()}</td>
        <td class="text-center">৳ ${dt.discount.toLocaleString()}</td>
        <td class="text-center"><strong>৳ ${dt.total.toLocaleString()}</strong></td>
      </tr>
    `;
  }).join('');

  return `
    <div class="header">
      <div class="company-name">MEDIPLUS MEDICAL SERVICES (Pvt) LTD.</div>
      <div class="report-title">Monthly Collection Short</div>
      <div class="date-info">Collection Month: ${collectionDate} <br/> Printing Time: ${printingTime}</div>
    </div>

    <table>
      <thead>
        <tr>
          <th>Day</th>
          <th>Advance</th>
          <th>Due</th>
          <th>Less</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        ${bodyRows}
        <tr class="total-row">
          <td class="text-center"><strong>Total</strong></td>
          <td class="text-center"><strong>৳ ${overallPaid.toLocaleString()}</strong></td>
          <td class="text-center"><strong>৳ ${overallDue.toLocaleString()}</strong></td>
          <td class="text-center"><strong>৳ ${overallDiscount.toLocaleString()}</strong></td>
          <td class="text-center"><strong>৳ ${overallTotal.toLocaleString()}</strong></td>
        </tr>
      </tbody>
    </table>
  `;
};

const printMonthlyCollectionShort = (superGroups, orders) => {
  const sgs = Array.isArray(superGroups) ? superGroups : [];
  const rows = Array.isArray(orders) ? orders : [];

  const firstDate = rows.length > 0 && rows[0].createdAt ? moment(rows[0].createdAt) : moment();
  const collectionMonth = firstDate.format('MMMM YYYY');
  const printTitle = `Monthly Collection Short - ${collectionMonth}`;
  const printContent = generatePrintableContent(sgs, rows) || '<div style="padding:20px;">No data to print</div>';

  const fullHtml = `
    <html>
      <head>
        <title>${printTitle}</title>
        <style>
          ${defineCss()}
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `;

  openPrintPreview(fullHtml, printTitle);
};

export default printMonthlyCollectionShort;
